import __request__ from 'routing/request';
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
interface SymantecSESRequestImpl {
    readonly oauth_credentials: unknown;
    readonly ses_base_url: string;
}
interface SymantecSESCreateInputRequest {
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly stream_guid: string;
    readonly no_of_channels: number;
    readonly checkpoint_interval_seconds: number;
    readonly oauth_credentials: unknown;
    readonly name: string;
    readonly content_types: string[];
    readonly stream_connection_timeout: number;
    readonly ses_base_url: string;
    readonly enable_throttling: boolean;
    readonly polling_interval: number;
}
/**
 * Validate API Credentials
 */
export function checkCredentials(JSONbody: SymantecSESRequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.symantecses.api.SymantecSESResource/symantecses/checkCredentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new Symantec SES input
 */
export function create(JSONbody: SymantecSESCreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.symantecses.api.SymantecSESResource/symantecses/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
